<template>
  <div class="home">
    <div class="main_area">
      <div id="main_area_center">
        <div class="sub_menu">
          <!-- SPA ER -->

          <span>
            <a-button
              @click="setSpa('s')"
              type="ghost"
              shape="round"
              :style="[
                spa == 's'
                  ? {
                      backgroundColor: 'teal',
                      color: 'white',
                      borderColor: 'teal',
                    }
                  : {},
              ]"
              style="margin-right: 14px"
            >
              Santé
            </a-button>

            <a-button
              @click="setSpa('p')"
              type="ghost"
              shape="round"
              :style="[
                spa == 'p'
                  ? {
                      backgroundColor: 'brown',
                      color: 'white',
                      borderColor: 'brown',
                    }
                  : {},
              ]"
            >
              Prévoyance
            </a-button>

            <a-button
              v-if="false"
              @click="setSpa('a')"
              type="ghost"
              shape="round"
              :style="[
                spa == 'a'
                  ? {
                      backgroundColor: 'orange',
                      color: 'white',
                      borderColor: 'orange',
                    }
                  : {},
              ]"
            >
              Autres risques
            </a-button>
          </span>
        </div>

        <a-divider>
          Synthèse de mon Portefeuille Client {{ getThisYear }}
        </a-divider>

        <p style="text-align: center">
          Consulter les données clés de mon portefeuille clients (holdings,
          entreprises, contrats, cotisations, assurés) et créer un graphique
          sur-mesure en sélectionnant les données souhaitées de mon portefeuille
        </p>

        <div style="display: flex">
          <div class="s_group" :style="'border-top: 3px solid ' + spaColor">
            <div class="s_t">Holdings</div>
            <div class="s_n">
              <An :numberFormat="true" :number="miHolding" />
            </div>
            <div class="s_i"></div>
          </div>

          <div class="s_group" :style="'border-top: 3px solid ' + spaColor">
            <div class="s_t">Entreprises</div>
            <div class="s_n">
              <An :numberFormat="true" :number="miEntreprise" />
            </div>
            <div class="s_i"></div>
          </div>

          <div class="s_group" :style="'border-top: 3px solid ' + spaColor">
            <div class="s_t">Assurés et ayants droit</div>
            <div class="s_n">
              <An :numberFormat="true" :number="miAssure" />
            </div>
            <div class="s_i"></div>
          </div>
        </div>

        <div v-if="spa != 'a'" style="display: flex">
          <div class="s_group" :style="'border-top: 3px solid ' + spaColor">
            <div class="s_t">Prestations survenues</div>
            <div v-if="spa == 's'" class="s_n">
              <An :numberFormat="true" :number="miPrestation" /> €
            </div>
            <div v-if="spa == 'p'" class="s_n">
              <a-popover placement="leftTop">
                <template #content>
                  <div style="width: 300px">
                    Compte tenu du fait que notre délégation de gestion est
                    limitée aux règlements du risque incapacité de travail, nous
                    vous remercions de vous rapprocher de votre assureur pour
                    obtenir le montant exhaustif des prestations (Sinistres
                    Décès, Incapacité, Invalidité et provisions associées)
                  </div>
                </template>
                ?
              </a-popover>
            </div>
            <div class="s_i"></div>
          </div>
          <div class="s_group" :style="'border-top: 3px solid ' + spaColor">
            <div class="s_t">Cotisations encaissées</div>
            <div class="s_n">
              <An :numberFormat="true" :number="miCotisation" /> €
            </div>
            <div class="s_i"></div>
          </div>
        </div>

        <a-divider></a-divider>

        <div
          style="display: flex; justify-content: space-evenly; margin-top: 48px"
        >
          <div class="tp_part_group">
            <a-button
              type="ghost"
              shape="round"
              size="large"
              style="background-color: blue; color: white; margin-bottom: 24px"
              @click="$router.push('/search')"
            >
              Recherche d'un assuré ou d'une entreprise
            </a-button>

            <div>
              Consulter les données d'une entreprise ou d'un assuré<br />(télétransmission,
              carte tiers-payant)
            </div>
          </div>
          <div class="tp_part_group">
            <a-button
              type="ghost"
              shape="round"
              size="large"
              style="background-color: green; color: white; margin-bottom: 24px"
              @click="$router.push('/extraction')"
            >
              Outil d'extraction
            </a-button>

            <div>
              Rechercher les données de mon portefeuille et<br />les exporter au
              format Excel
            </div>
          </div>
          <div class="tp_part_group">
            <a-button
              type="ghost"
              shape="round"
              size="large"
              style="background-color: brown; color: white; margin-bottom: 24px"
              @click="$router.push('/documents')"
            >
              Bibliothèque de documents
            </a-button>

            <div>Accéder aux documents utiles<br />à mon activité</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue"

export default {
  name: "home",
  components: { An },
  data: () => {
    return {
      spa: "s",
      colors: {
        s: "teal",
        p: "brown",
        a: "orange",
      },
    };
  },
  methods: {
    setSpa(spa) {
      this.spa = spa;
    },
  },
  computed: {
    getThisYear() {
      var d = new Date();
      return d.getFullYear();
    },
    spaColor() {
      return this.colors[this.spa];
    },
    mainInfo() {
      return this.$store.getters.mainInfo;
    },
    miHolding() {
      return this.mainInfo.holdingCount[this.spa];
    },
    miEntreprise() {
      return this.mainInfo.companyCount[this.spa];
    },
    miAssure() {
      return this.mainInfo.assureBenefCount[this.spa];
    },
    miCotisation() {
      return this.mainInfo.cotisationCount[this.spa];
    },
    miPrestation() {
      return this.mainInfo.prestationCount[this.spa];
    },
  },
  mounted() {
    setTimeout(() => {
      document.getElementsByClassName("sub_menu")[0].style.top = "60px";
    }, 10);
  },
};
</script>

<style media="screen">
div.s_group {
  width: 100%;
  height: 100px;
  position: relative;
  background-color: white;
  border-top: 3px solid #008281;
  user-select: none;
  border-radius: 4px;
  display: inline-block;
  margin: 6px;
  box-shadow: 0 0 2px #9c9c9c;
}

div.s_t {
  position: absolute;
  color: #263e51;
  font-size: 18px;
  right: 20px;
  top: 14px;
}
div.s_n {
  position: absolute;
  color: #263e51;
  font-size: 34px;
  right: 19px;
  bottom: 0;
  font-weight: bold;
}
div.s_v {
  position: absolute;
  color: black;
  font-weight: bold;
  bottom: 8px;
  left: 20px;
}

div.s_i {
  position: absolute;
  color: white;
  font-weight: bold;
  bottom: 10px;
  left: 0;
}

.tp_part_group {
  text-align: center;
  margin: 20px;
}
</style>
